import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navbar from "../components/Navbar"
import Imprint from "../components/Imprint"
import Feedback from "../components/Feedback"
import Footer from "../components/Footer"

const ImprintPage = () => (
  <Layout>
    <SEO title="Impressum | HeyPixie" keywords={[`startup`, `gebraucht verkaufen`, `inventar`, 'digital']} />
    <Navbar />
    <Imprint />
    <Feedback />
    <Footer />
  </Layout>
)

export default ImprintPage
